var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 0H0V2H40V0ZM40 4H0V6H40V4ZM0 8H40V10H0V8ZM40 12H0V14H40V12ZM0 16H40V18H0V16ZM40 20H0V22H40V20ZM0 24H40V26H0V24ZM40 28H0V30H40V28ZM0 32H40V34H0V32ZM40 36H0V38H40V36Z",
    fill: "#CC0001"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#010066"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 10.2353C4 7.89748 5.9038 6 8.24938 6C9.12898 6 9.94655 6.26696 10.6248 6.72376C10.2174 6.57337 9.7771 6.49128 9.31746 6.49128C7.23757 6.49128 5.54953 8.17371 5.54953 10.2467C5.54953 12.3197 7.23757 14.0021 9.31746 14.0021C9.74891 14.0021 10.1634 13.9292 10.5495 13.7959C9.88638 14.2226 9.09682 14.4705 8.24938 14.4705C5.9038 14.4705 4 12.5731 4 10.2353ZM13.5065 11.506L15.2965 12.4399L13.9694 10.9418L15.9975 11.0258L14.1353 10.2376L16 9.45505L13.9716 9.53294L15.3035 8.03882L13.5106 8.96735L14.0458 7.0576L12.8436 8.65285L12.4762 6.70572L12.1027 8.65173L10.9055 7.05287L11.4347 8.96422L9.64477 8.03031L10.9719 9.52843L8.94374 9.44443L10.806 10.2326L8.94126 11.0152L10.9697 10.9373L9.63781 12.4314L11.4307 11.5029L10.8954 13.4126L12.0977 11.8174L12.4651 13.7645L12.8386 11.8185L14.0358 13.4173L13.5065 11.506Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyr);
export default __webpack_public_path__ + "static/media/myr.c2aecf547ca900a386c742cc557b0333.svg";
export { ForwardRef as ReactComponent };